import React, { useState } from "react";
import { useRouter } from "next/router";

import CategoryBanner from "./Category-Banner";
import CategoryBannerdata from "./Category-Bannerdata";
import { useAppContext } from "@/context/Context";

const CategoryHead = ({
  category,
  courses,
  filterItem,
  courseFilter,
  setCourseFilter,
  navData
}) => {
  const router = useRouter();
  const path = router.pathname;
  const { toggle, setToggle } = useAppContext();
  const [filterToggle, setFilterToggle] = useState(true);
  const [activeTab, setActiveTab] = useState("All Course");

  const handleButtonClick = (courseType) => {
    setCourseFilter(category);
    setActiveTab(courseType);
    filterItem(courseType);
  };
  // const isStudyCoursesPage = window.location.pathname === '/study-courses';
  const [toggleBackground, setToggleBackground] = useState(false);

  const gradient1 =
    "linear-gradient(25deg, rgb(14, 20, 46) 50%, rgb(157, 86, 24) 100%) ";
  const gradient2 =
    "linear-gradient(25deg, rgba(14, 20, 46, 1) 0%, rgba(16, 24, 113, 1) 100%) ";
  const style = {
    background: gradient1,
    transition: "background 0.3s ease", // Optional: adds a smooth transition effect
  };

  const toggleMenuItem = (item) => {
    setActiveMenuItem(activeMenuItem === item ? null : item);
  };
  return (
    <>
      <div
        className="rbt-page-banner-wrapper cursor-pointer"
        onClick={() => setToggleBackground(!toggleBackground)}
      >
        <div className="rbt-banner-image cursor-pointer" style={style}></div>

        <div className="rbt-banner-content">
        {category ? (
        <CategoryBanner category={category} navData={navData} />
      ) : courses ? (
        <CategoryBannerdata courses={courses} navData={navData} />
      ) : null}





        </div>
      </div>
    </>
  );
};

export default CategoryHead;
